import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "issue-table"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = ["href"];
import { ref, onMounted, toRefs, watch } from 'vue';
import { mctRequest } from '@/api/axios';
import { storeToRefs } from 'pinia';
import { useDetailStatusStore } from '@/store/detailStatus';
export default /*@__PURE__*/_defineComponent({
  __name: 'IssueTable',
  props: {
    serverId: {}
  },
  setup(__props) {
    const detailStatusStore = useDetailStatusStore();
    const {
      refreshIssueTable
    } = storeToRefs(detailStatusStore);
    const props = __props;
    const {
      serverId
    } = toRefs(props);
    const tableData = ref([]);
    // @ts-ignore
    const snowWorkOrderSite = ref(window.envConfig?.snowWorkOrderSite);
    // @ts-ignore
    const snowIssueSite = ref(window.envConfig?.snowIssueSite);
    const getIssue = async () => {
      tableData.value = [];
      const config = {
        url: `/issue?serverId=${serverId.value}`
      };
      const {
        IssueList
      } = await mctRequest.request(config);
      tableData.value = [].concat(...IssueList.map(subArray => [].concat(...subArray)));
    };
    onMounted(() => {
      getIssue();
    });
    watch(refreshIssueTable, () => {
      getIssue();
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_table, {
        data: tableData.value,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "incidentId",
          label: "Issue ID"
        }, {
          default: _withCtx(scope => [scope.row?.workOrderId?.startsWith('RITM') ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: snowWorkOrderSite.value + scope.row.workOrderId,
            class: "mct-blue",
            target: "_blank"
          }, _toDisplayString(scope.row.workOrderId), 9, _hoisted_2)) : scope.row?.issueId?.startsWith('ISSUE') ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: snowIssueSite.value + scope.row.issueId,
            class: "mct-blue",
            target: "_blank"
          }, _toDisplayString(scope.row.issueId), 9, _hoisted_3)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "summary",
          label: "Summary",
          width: "400"
        }), _createVNode(_component_el_table_column, {
          prop: "userName",
          label: "Submitter"
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "Status"
        }), _createVNode(_component_el_table_column, {
          prop: "submitTimeStr",
          label: "Date"
        })]),
        _: 1
      }, 8, ["data"])]);
    };
  }
});